import React, { useContext, useState, useEffect } from 'react'
import { FormattedMessage } from '~/translations/utils'
import { formatDistance } from '~/utils/dateFns'
import { TicketContext } from '~/components/tickets/Show'
import { Collapse } from 'antd'
import { formatDate, formatRelative } from '~/utils/dateFns'
import Tags from './info/Tags'
import store from 'store2'

const Info: React.FC = ({}) => {
  const { ticket, reportType, clientAvatar } = useContext(TicketContext)
  const client = ticket.client

  const [showInfo, setShowInfo] = useState(
    store.has('ticket_info') ? store.get('ticket_info') : true
  )

  const Details = () => (
    <div className="ticket-show-info__box">
      {ticket.category && (
        <div className="ticket-show-info">
          <span className="ticket-show-info__title">
            <FormattedMessage id="ticket / details / category" />
          </span>
          {ticket.category.name}
          {ticket.subcategory && ' - ' + ticket.subcategory.name}
        </div>
      )}

      {ticket.status && (
        <div className="ticket-show-info__item">
          <span className="ticket-show-info__title">
            <FormattedMessage id="ticket / details / status" />
          </span>
          {ticket.status.name}
        </div>
      )}

      {ticket.emailFrom && (
        <div className="ticket-show-info__item">
          <span className="ticket-show-info__title">
            <FormattedMessage id="ticket / details / from" />
          </span>
          {ticket.emailFrom}
        </div>
      )}
      {client && (
        <div className="ticket-show-info__item">
          <span className="ticket-show-info__title">
            <FormattedMessage id="ticket / details / reportedBy" />
          </span>
          {reportType?.name}
        </div>
      )}
      {!ticket.closed && ticket.withoutConsultantAnswer && client && (
        <div className="ticket-show-info__item">
          <span className="ticket-show-info__title">
            <FormattedMessage id="ticket / details / clientWaits" />
          </span>
          {formatDistance(new Date(ticket.dateLastAnswer.date))}
        </div>
      )}
      {!ticket.closed && (
        <div className="ticket-show-info__item">
          <span className="ticket-show-info__title">
            <FormattedMessage id="ticket / details / lasts" />
          </span>
          {formatDistance(new Date(ticket.added.date))}
        </div>
      )}
      {ticket.closed && (
        <div className="ticket-show-info__item">
          <span className="ticket-show-info__title">
            <FormattedMessage id="ticket / details / lasted" />
          </span>
          {formatDate(new Date(ticket.added.date), 'P')}
        </div>
      )}
      {ticket.assignedUsers && (
        <div className="ticket-show-info__item">
          <span className="ticket-show-info__title">
            <FormattedMessage id="ticket / details / assignedUsers" />
          </span>
          {ticket.assignedUsers.length ? (
            ticket.assignedUsers.map((id, index) => {
              const user = window.c.users.find(e => e.id == id)
              const last = ticket.assignedUsers.length - 1 == index

              return (
                <span key={id}>
                  <a href={'/user/' + id}>{user?.name}</a>
                  {!last && ', '}
                </span>
              )
            })
          ) : (
            <FormattedMessage id="ticket / details / assignedUsersNoone" />
          )}
        </div>
      )}
      {ticket.deadline && (
        <div className="ticket-show-info__item">
          <span className="ticket-show-info__title">
            <FormattedMessage id="ticket / details / deadline" />
          </span>
          {formatRelative(new Date(ticket.deadline.date))}
        </div>
      )}
      <div className="ticket-show-info__item">
        <span className="ticket-show-info__title">
          <FormattedMessage id="ticket / details / tags" />
        </span>
        <Tags />
      </div>
    </div>
  )

  return (
    <>
      {client && (
        <Collapse
          className="ticket-show-info"
          ghost
          defaultActiveKey={showInfo ? 1 : undefined}
          onChange={() => {
            setShowInfo(!showInfo)
            store.set('ticket_info', !showInfo)
            console.log(store.get('ticket_info'))
          }}
          items={[
            {
              key: '1',
              label: (
                <div className="ticket-show-info__client">
                  <img src={clientAvatar} alt={client.name} />
                  <span>{client.name}</span>
                </div>
              ),
              children: <Details />,
              extra: <span>{formatDistance(new Date(ticket.added.date))}</span>,
            },
          ]}
        />
      )}
    </>
  )
}

export default Info
